<script>
	// Stores
	import ResultStore from '@/Stores/Racing/ResultStore.js';
	import RaceStore from '@/Stores/Racing/RaceStore.js';
	// Partials
	import RaceResults from '@/Partials/Racing/Results/RaceResults.svelte';

	export let selectedRaceId;

	$: race = $RaceStore.firstWhere('id', selectedRaceId);
	$: results = $ResultStore;
</script>

<div class="container h-40 overflow-y-auto border">
	{#if $ResultStore && $ResultStore.placings}
		<RaceResults bind:results {race} />
	{:else}
		<div class="pt-1 text-center text-light-grey">No results for this race.</div>
	{/if}
</div>
